'use client';
import React, { useState } from 'react';
import { VIBE_FILTERS } from '@/data/mockCafes';

interface VibeFiltersProps {
  onFilterChange?: (activeFilters: string[]) => void;
}

export default function VibeFilters({ onFilterChange }: VibeFiltersProps) {
  const [activeFilters, setActiveFilters] = useState<string[]>([]);

  const toggleFilter = (filterId: string) => {
    const updated = activeFilters.includes(filterId)
      ? activeFilters.filter((f) => f !== filterId)
      : [...activeFilters, filterId];
    setActiveFilters(updated);
    onFilterChange?.(updated);
  };

  return (
    <div className="mb-6">
      <div className="flex items-center gap-2 overflow-x-auto scrollbar-hide pb-2">
        <button
          onClick={() => { setActiveFilters([]); onFilterChange?.([]); }}
          className={`vibe-chip flex-shrink-0 ${activeFilters.length === 0 ? 'active' : ''}`}
        >
          🏠 Semua
        </button>
        {VIBE_FILTERS.map((filter) => (
          <button
            key={`vibe-${filter.id}`}
            onClick={() => toggleFilter(filter.id)}
            className={`vibe-chip flex-shrink-0 ${activeFilters.includes(filter.id) ? 'active' : ''}`}
          >
            {filter.emoji} {filter.label}
          </button>
        ))}
      </div>
      {activeFilters.length > 0 && (
        <p className="text-xs text-muted-foreground mt-2">
          Filter aktif: <span className="text-accent font-600">{activeFilters.length} vibe</span> dipilih
          {' · '}
          <button onClick={() => { setActiveFilters([]); onFilterChange?.([]); }} className="text-accent underline">Reset</button>
        </p>
      )}
    </div>
  );
}